import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'antd'

const NumericInput = props => {
  const { value, onBlur, onChange } = props

  const onChangeIntern = e => {
    const val = e.target.value

    if (!Number.isNaN(Number(val)) || val === '' || val === '-') {
      onChange(val)
    }
  }

  // '.' at the end or only '-' in the input box.
  const onBlurIntern = () => {
    if ((value && value.charAt(value.length - 1) === '.') || value === '-') {
      onChange(value.slice(0, -1))
    }
    if (onBlur) {
      onBlur()
    }
  }

  return <Input {...props} onChange={onChangeIntern} onBlur={onBlurIntern} maxLength={25} />
}

NumericInput.propTypes = {
  value: PropTypes.any,
  onBlur: PropTypes.func,
  onChange: PropTypes.func
}

export default NumericInput
